import { StateCreator } from 'zustand';
import { createAppStore } from './zustand';
import { produce } from 'immer';

interface envVarsType {
  [ENV_VAR: string]: string;
}

interface envVarsState {
  envVarsObject: envVarsType;
  setEnvVars?: (envVars: envVarsType) => void;
}

const initialState: envVarsState = {
  envVarsObject: {},
};

export const clientEnvVarsStore: StateCreator<envVarsState> = (set, get) => {
  return {
    ...initialState,
    mergeEnvVars: (envVars: envVarsType) => {
      set(state => ({
        envVarsObject: {
          ...state.envVarsObject,
          ...envVars,
        },
      }));
    },
    setEnvVars: (envVars: envVarsType) => {
      set({ envVarsObject: { ...envVars } });
      if (!Object.keys(get().envVarsObject).length) set({ envVarsObject: { ...envVars } });
    },
    updateEnvVar: (key: string, value: string) => {
      set(produce(draft => (draft.envVarsObject[key] = value)));
    },
  };
};

export const useClientEnvVarsStore = createAppStore(clientEnvVarsStore, {
  usePersistentStore: false,
});
